import type {DeviceBase, HapticFeedbackType} from './base';

class Device implements DeviceBase {
  getLocale(short?: boolean): string {
    const locale = (navigator.language || navigator['userLanguage']);
    return short ? locale.split('-').shift() : locale;
  }

  share(url: string, title: string) {
    navigator.share({url, title}).catch(() => {});
  }

  restartApp() {
    location.reload();
  }
  
  isDarkMode() {
    return matchMedia('(prefers-color-scheme: dark)').matches;
  }

  dismissKeyboard() {
    // Noop on web
    return;
  }

  triggerHapticFeedback(_type: HapticFeedbackType) {
    // Noop on web
    return;
  }

  clipboardSet(text: string) {
    try {
      navigator.clipboard.writeText(text);
    } catch (error) {
      // Fallback for older browsers
      if (typeof document !== 'undefined' && document.execCommand) {
        document.execCommand('copy', false, text);
      }
    }
  }
  
  async clipboardGet(): Promise<string> {
    return await navigator.clipboard.readText();
  }
}

export default new Device();
